import { Flex } from "@chakra-ui/react";
import * as React from "react";

import Button from "components/Chakra/Button";
import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";
import { useShareModal } from "modals/useShareModal";
import { useReportModal } from "modals/useReportModal";
import IconShare from "components/Chakra/Icons/Share";
import IconSound from "components/Chakra/Icons/Sound";

const Actions: React.FC<IMarginProps> = ({ ...margins }) => {
  const { openModal: openShareModal } = useShareModal();
  const { openModal: openReportModal } = useReportModal();

  const { offer } = useDetailState();

  if (!offer) {
    return null;
  }

  return (
    <Flex justify="space-between" {...margins}>
      <Button
        w="calc(50% - 5px)"
        variant="small_outline"
        trackEventPayload={{
          "dl.eCat": "detail_inzeratu",
          "dl.eAct": "report_click",
          "dl.eLab": offer?.id?.toString() ?? "0",
        }}
        onClick={() => openReportModal({ offer })}
        leftIcon={<IconSound />}
        data-test="offerDetail.actionButton.alert"
      >
        Nahlásit inzerát
      </Button>

      {/*
      <Button
        px="10px"
        variant="small_outline"
        trackEventPayload={{
          "dl.eCat": "detail_inzeratu",
          "dl.eAct": "tisknout_click",
          "dl.eLab": offer.id.toString(),
        }}
        onClick={() => {
          typeof window !== "undefined" && window.print();
        }}
        leftIcon={<IconPrint />}
        data-test="offerDetail.actionButton.print"
      >
        Tisk
      </Button>
      */}

      <Button
        w="calc(50% - 5px)"
        variant="small_outline"
        trackEventPayload={{
          "dl.eCat": "detail_inzeratu",
          "dl.eAct": "share_click",
          "dl.eLab": offer?.id?.toString() ?? "0",
        }}
        onClick={() => offer && openShareModal({ offer })}
        leftIcon={<IconShare />}
        data-test="offerDetail.actionButton.share"
      >
        Sdílet
      </Button>
    </Flex>
  );
};

export default Actions;
